import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import { ComposableMap, ZoomableGroup, Geographies, Geography } from 'react-simple-maps'
import Popover from '@material-ui/core/Popover'

import { withStyles } from '@material-ui/core/styles'

import chroma from'chroma-js'

import ItalyRegions from './../../../assets/maps/italy-regions-simple.topo.json'
import { ItalianRegionsCenter } from './../../../libs/ItalianRegions'
import { ColorPalette, heatmapColor, comparatorDataFilter } from './../../../libs/DataUtilities'

import DataPopoverContent from './map_visualizer/DataPopoverContent'

import find from 'lodash/find'
import min from 'lodash/min'
import max from 'lodash/max'
import compact from 'lodash/compact'
import reject from 'lodash/reject'

import './MapVisualizer.css'

const styles = theme => ({
    popover: {
      pointerEvents: 'none'
    }
})

class MapVisualizer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            firstLoadHack: false,
            dataPopoverAnchorEl: null
        }

        this.regionRefs = {}
    }

    /* Methods */
    handleMove = (geography, event) => {
        if(this.props.currentSelection.region != geography.properties.NAME_1) {
            this.props.currentSelectionChange(geography.properties.NAME_1, null, null)
        }
    }

    handleLeave = (geography, event) => {
        if(this.props.currentSelection.region != null) {
            this.props.currentSelectionChange(null, null, null)
        }
    }

    fireEvent = (domElement, eventName) => {
        if(domElement != null) {   
          if(domElement.fireEvent) {
            domElement.fireEvent('on' + eventName);     
          } else {   
            var evObj = document.createEvent('Events');
            evObj.initEvent(eventName, true, false);
            domElement.dispatchEvent(evObj);
          }
        }
      }

    /* Lifecycle */

    componentDidMount() {
        setTimeout(() => { this.setState({ firstLoadHack: true }) }, 0) // React Simple Map has a problem with dynamic dimension on mobile devices on first load... this hack resolve the problem :-|
    }

    componentDidUpdate() {
        const regionDom = this.props.currentSelection.region ? ReactDOM.findDOMNode((this.regionRefs[this.props.currentSelection.region] || {}).current) : null

        if(regionDom != this.state.dataPopoverAnchorEl) {
            this.fireEvent(this.state.dataPopoverAnchorEl, 'mouseout')
            this.setState({dataPopoverAnchorEl: regionDom}, () => {
                this.fireEvent(regionDom, 'mousemove')
            })
        }
    }
     
    render() {
        const { classes, region, data } = this.props
        const { currentSelection } = this.props

        /* Prepare Map */
        const center = ItalianRegionsCenter[this.props.region].center
        const zoom = ItalianRegionsCenter[this.props.region].zoom

        const { white, taVeryLight } = ColorPalette

        
        const currentVisualizedDataType =  (this.props.shownDataType && this.props.shownDataType != 'all' ? this.props.shownDataType : null) || this.props.currentSelection.dataType
        const keyShownData = this.props.shownSource && this.props.shownSource != 'all' ? this.props.shownSource : currentVisualizedDataType

        const allValueData = reject(data, {region: 'all'}).map((e, i) => (find(e.data, {key: keyShownData}) || {}).value)
        const minValueData = min(compact(allValueData))
        const maxValueData = max(compact(allValueData))

        const map = (
            <ComposableMap
                        width={600}
                        height={600}
                        projection="times"
                        projectionConfig={{
                            scale: 3000
                        }}
                        style={{
                            width: '100%',
                            height: 'auto',
                            overflow: 'hidden'
                        }}>
                <ZoomableGroup center={center} zoom={zoom} disablePanning>
                    <Geographies geography={ItalyRegions} disableOptimization>
                        {(geographies, projection) => geographies.map((geography, index) => {
                            if(region === 'all' || geography.properties.NAME_1 == region) { 

                                /* Find data for region */
                                const regionalData = find(data, {region: geography.properties.NAME_1, data_type: currentVisualizedDataType}) || {}
                                const valueData = find(regionalData.data, {key: keyShownData}) || {}

                                /* Prepare colors for region */
                                const baseFillColor = ColorPalette[valueData.source] || white
                                const fillColor = heatmapColor(valueData.value, minValueData, maxValueData, baseFillColor) || white
                                const strokeColor = fillColor != white ? white : taVeryLight
                                const hoverFillColor = chroma(baseFillColor).darken()
                                const hoverStrokeColor = strokeColor

                                /* Set Dom refs for region */
                                this.regionRefs[geography.properties.NAME_1] = React.createRef()

                                return (
                                    <Geography
                                        ref={this.regionRefs[geography.properties.NAME_1]}
                                        key={`${geography.properties.NAME_1}-${index}-${this.props.index}`}
                                        cacheId={`${geography.properties.NAME_1}-${index}-${this.props.index}`}
                                        geography={ geography }
                                        projection={ projection }
                                        style={{
                                            default: { fill: fillColor, stroke: strokeColor },
                                            hover:   { fill: hoverFillColor, stroke: hoverStrokeColor },
                                            pressed: { fill: hoverFillColor, stroke: hoverStrokeColor },
                                        }}
                                        round
                                        onMouseMove={this.handleMove}
                                        onMouseLeave={this.handleLeave}/>
                                )
                            }
                            else {
                                return null
                            }
                        })}
                    </Geographies>
                </ZoomableGroup>
            </ComposableMap>
        )

        /* Prepare Popover */

        const filteredData = comparatorDataFilter(data, currentSelection.region, currentSelection.dataType, this.props.shownSource)

        const popover = (
            <Popover
                className={classes.popover}
                BackdropProps={{
                    invisible: true
                }}
                open={ !!this.state.dataPopoverAnchorEl }
                anchorEl={ this.state.dataPopoverAnchorEl }
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                disableRestoreFocus>
                <DataPopoverContent region={currentSelection.region} data={filteredData}/>
            </Popover>
        )

        return (
            <div className="pages-shared-map-visualizer">
                <div className="pages-shared-map-visualizer__wrap">
                    { this.state.firstLoadHack ? map : null }
                </div>
            
                { currentSelection.region ? popover : null }
            </div>       
        )
    }
}

export default withStyles(styles)(MapVisualizer)


// WEBPACK FOOTER //
// ./src/components/pages/shared/MapVisualizer.js